/*========================================
        Imports!!!
=========================================*/

/*--css--*/
import '../assets/css/dom.css';
import Header from './header.js';
import Footer from './footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/*--img in content--*/
import Main from '../assets/img/img12.webp';

import sprzet1 from '../assets/produkty/namiotRatunkowy.webp';
import sprzet2 from '../assets/produkty/NamiotPneumatyczny.webp';
import sprzet3 from '../assets/produkty/namiotSferyczny.webp';
import sprzet4 from '../assets/produkty/NamiotŚwietlica.webp';
import sprzet5 from '../assets/produkty/wypKwaterunkowe.webp';
import sprzet6 from '../assets/produkty/FilaDach.webp';

/*========================================
        Middle!!!
=========================================*/

function Middle() {
    return (
        <>
        <section className='Middle'>
            {/*--stick publicity--*/}
            <section className='publicity'>
                <Row className='entry'>
                    {/*--text--*/}
                    <Col lg={5} md={12} sm={12} className='p-1 describe'>
                        <h1> Sprzęt logistyczny i kwaterunkowy</h1>
                        <h5>
                            Sprzęt logistyczny i kwaterunkowy zapewnia komfort i organizację działań w terenie. Namioty, zbiorniki czy przyczepy ułatwiają pracę ratowników i wspierają działania w trudnych warunkach.
                        </h5>
                    </Col>
                    {/*--img--*/}
                    <Col lg={6} md={12} sm={12} className='lg-p-3 xs-p-1'>
                        <div className="image-container">
                            <img src={Main} alt='ilustrations of the main theme'/>    
                        </div>
                    </Col >
                </Row>
                {/*--choose the stick--*/}
                <section className='ChooseYour'>
                    <Row className='EquipRow'>
                        <Col className='equipment'>
                            <img src={sprzet1} alt="sprzęt ilustracja"/>
                            <span>Namiot Ratowniczy</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet2} alt="sprzęt ilustracja"/>
                            <span>Namiot Pneumatyczny</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet3} alt="sprzęt ilustracja"/>
                            <span>Namiot Sferyczny</span>
                        </Col>
                    </Row> 
                    <Row className='EquipRow'>
                        <Col className='equipment'>
                            <img src={sprzet4} alt="sprzęt ilustracja"/>
                            <span>Namiot Swietlicowy</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet5} alt="sprzęt ilustracja"/>
                            <span>Wyposarzenie kwaterunkowe</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet6} alt="sprzęt ilustracja"/>
                            <span>Płachta na zwerwany dach</span>
                        </Col>
                    </Row>
                </section>
            </section>
          </section>
        </>
    );
}

function Equipment() {
    return (
        <>
          <Header />
          <Middle/>
          <Footer/> 
        </>
    );
}

export default Equipment;